import Catalog from './ProductsCatalog';
import Pagination from './ProductsPagination';
import Showcases from '../Showcases/ProductsShowcases';

import type { ProductsWidgetProps } from './Products.d';

const ProductsWidget = ({ config, ...options }: ProductsWidgetProps) => {
  const isCatalog = config.limit === 'off' && config.pagination;
  return isCatalog ? (
    <>
      <Catalog config={config} {...options} />
      <Pagination anchorId={options.widgetKey} />
    </>
  ) : (
    <Showcases />
  );
};

export default ProductsWidget;
